var initializeFadeInColumnsBlock = function(block){
	
	const elements = document.querySelectorAll('.scroll-alert:not(.set-up)');
	const options = {
		root: null,
		rootMargin: '0px 0px -50% 0px',
		threshold: 0
	};
	
	var observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			
			if(entry.isIntersecting) {
				entry.target.classList.add('active');
			} else if(entry.boundingClientRect.y > entry.rootBounds.y) {
				entry.target.classList.remove('active');
			}
				
		});
	}, options);
	
	elements.forEach(element => {
		element.classList.add('set-up');
		observer.observe(element);
	});

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-fade-in-columns').each(function(){
		initializeFadeInColumnsBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=fade-in-columns', initializeFadeInColumnsBlock);
